/** @jsx jsx */
import { css, jsx } from '@emotion/core'
import { NumberField } from 'components/form'
import { useFlags } from 'config/useFlagsContext'
import { useMemo } from 'react'

import { FactoryResultadoExameEspecificoFieldProps } from '../../model-resultadosExames'
import { getResultadoExameEspecificoProperties } from '../../util-resultadosExames'

export const ResultadoExameMarcadoresBioquimicosNumberField = (props: FactoryResultadoExameEspecificoFieldProps) => {
  const { name, exame, expanded } = props

  const { PILOTO_CASA_DECIMAL_RESULTADO_EXAME_ENABLED } = useFlags()

  const { maxLength } = getResultadoExameEspecificoProperties(exame, PILOTO_CASA_DECIMAL_RESULTADO_EXAME_ENABLED)

  const inputStyle = useMemo(() => styles(expanded), [expanded])

  return (
    <div
      css={css`
        margin-bottom: -1px;
      `}
    >
      <NumberField
        name={name}
        maxLength={maxLength}
        placeholder='Clique para inserir o resultado...'
        style={inputStyle}
      />
    </div>
  )
}

const styles = (expanded: boolean) => css`
  width: calc(100% + 1rem + 2px);
  margin: 0 calc((0.5rem + 1px) * -1);
  margin-bottom: ${expanded ? '0' : 'calc(-0.75rem - 1px)'};

  & + span[role='button'] {
    top: ${!expanded ? '4px' : '0'};
  }
`
